import React from 'react';
import '../../../Assets/Styles/RichTextEditor.css';

const Button = ({
    children,
    onClick,
    variant = 'default',
    size = 'default',
    className = '',
    disabled = false,
    type = 'button', // ✅ <-- valeur par défaut
    ...props
}) => {
    const baseClass = 'rte-btn';
    const variantClass = `rte-btn-${variant}`;
    const sizeClass = `rte-btn-${size}`;
    const disabledClass = disabled ? 'rte-btn-disabled' : '';

    return (
        <button
            type={type} // ✅ forçage explicite
            className={`${baseClass} ${variantClass} ${sizeClass} ${disabledClass} ${className}`}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
